// 管理側イベント管理: 3画面共通のタブナビゲーション
// 使用例: <AdminEventTabs active="create" />
import React from "react";
import { useNavigate } from "react-router-dom";
import "./OrganizationTree.css";

const TABS = [
  { key: "create", label: "イベント作成", path: "/event/create" },
  { key: "list", label: "イベント一覧", path: "/event/list" },
  { key: "anketo", label: "アンケート管理", path: "/event/anketo" },
];

const AdminEventTabs = ({ active, currentUser }) => {
  const navigate = useNavigate();
  const handleBack = () => {
        if (currentUser.is_staff === true || currentUser.is_superuser === true) {
            navigate("/dashboard");
        } else {
            navigate("/card_back");
        }
    };

  return (
    <>
      <div className="ec-header">
        <h2 className="ec-title">イベント管理</h2>
        <div className="ec-header-actions">
          <button type="button" className="ec-btn-back" onClick={handleBack}>
            メニュー画面に戻る
          </button>
        </div>
      </div>
      <div className="ec-tabs">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            type="button"
            className={`ec-tab${active === tab.key ? " ec-tab-active" : ""}`}
            onClick={() => navigate(tab.path)}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </>
  );
};

export default AdminEventTabs;
